import React, { useState, useEffect} from 'react';
import {Typography, Divider, Box, Paper, Link} from '@mui/material';

import Main from '../../../layouts/Main';
import Container from '../../../components/Container';

import eLibraryDocument from '../../../types/legal/eLibraryDocument';
import ChronologicalButtonList from './ChronologicalButtonList';
import PageBreadCrumbs from '../../../components/PageBreadcrumbs';

const GuidanceLetters = (): JSX.Element => {

  document.title = 'OCPF - Guidance Letters';

  const [guidanceLetters, setGuidanceLetters] = useState<eLibraryDocument[]>([]);
  const [years, setYears] = useState<(number)[]>([]);

  useEffect(() => {
    getGuidanceLetters();
  }, [])


  const getGuidanceLetters = async () => {
    try{
      await fetch(`${process.env.REACT_APP_API_BASE_URL}/legal/gls`)
      .then(result => result.json())
      .then(result => {
          setGuidanceLetters(result);
          const uniqueYears: number[] = Array.from(
            new Set(
              result.map((item: eLibraryDocument) => item.year) 
                .filter((year: number): year is number => year !== undefined)
            )
          );
          setYears(uniqueYears);
      });

    }catch(error){
      console.error('Uncaught Error:', error);
    }
  }


  //const years = Array.from({ length: new Date().getFullYear() - 1995 + 1 }, (_, i) => new Date().getFullYear() - i);

  return (
    <Main>
      <Container>
      <PageBreadCrumbs></PageBreadCrumbs>
      <Typography
                variant="h5"
                align={'left'}
                data-aos={'fade-up'}
                gutterBottom
                sx={{
                  fontWeight: 700,
                }}
                paddingTop={3}>
                 OCPF Guidance Letters   <Typography component="span" variant="caption" color="text.secondary">by Year Issued</Typography>
              </Typography>



    
        <Divider/>
        <Box sx={{marginTop: 2, marginBottom: 2}}>
            <Typography variant="h6" align={'left'} paddingTop={1} paddingLeft={2} fontWeight={'bold'}>
            What is a Guidance Letter?
              </Typography>
              <Typography variant="body1" align={'left'} paddingLeft={2} paddingRight={2}>
              Guidance letters answer questions generally not relating to an issue previously addressed in an advisory opinion, memorandum or interpretative bulletin. Requests for a guidance letter may be submitted by candidates, committees or the public by e-mailing <Link href="mailto:ocpf@mass.gov" color="primary" underline="hover">
      ocpf@mass.gov
    </Link>.
              </Typography>
        </Box>
        <ChronologicalButtonList years={years} eLibraryDocuments={guidanceLetters} eLibraryDocumentType={'Guidance Letters'} />

      </Container>
    </Main>
  );
}

export default GuidanceLetters;

